export const GET_PENDING_AND_CANCEL_REQUEST = "GET_PENDING_AND_CANCEL_REQUEST";
export const GET_PENDING_AND_CANCEL_SUCCESS = "GET_PENDING_AND_CANCEL_SUCCESS";
export const GET_PENDING_AND_CANCEL_FAIL = "GET_PENDING_AND_CANCEL_FAIL";